//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

export interface LoopLinksResponse {
  planLoop?: string;
  testLoop?: string;
  measureLoop?: string;
  releaseLoop?: string;
  deployLoop?: string;
  controlLoop?: string;
  loopName?: string;
  teamspaceName?: string;
  [key: string]: string | undefined;
}

// Internal variable to hold the latest response in memory
let latestLoopLinksResponse: LoopLinksResponse = {};

// Persist the latest response to context
function persistToStorage(
  response: LoopLinksResponse,
  setLoopLinksResponseInContext: (value: LoopLinksResponse) => void,
) {
  setLoopLinksResponseInContext(response);
}

// Set the latest loopLinks response (call this after fetching from API)
export function setLoopLinksResponse(
  response: LoopLinksResponse,
  setLoopLinksResponseInContext: (value: LoopLinksResponse) => void | undefined,
  loopName?: string,
  teamspaceName?: string,
) {
  latestLoopLinksResponse = {
    ...response,
    loopName: loopName ?? response.loopName,
    teamspaceName: teamspaceName ?? response.teamspaceName,
  };
  persistToStorage(latestLoopLinksResponse, setLoopLinksResponseInContext);
}

export interface TeamspaceItem {
  id: string;
  name: string;
  [key: string]: any;
}

const latestTeamspacesList: TeamspaceItem[] = [];

function persistTeamspacesToStorage(
  teamspaces: TeamspaceItem[],
  setTeamspacesListInContext: (value: TeamspaceItem[]) => void,
) {
  try {
    setTeamspacesListInContext(teamspaces);
  } catch (e) {}
}

// Set the latest teamspaces list
export function setTeamspacesList(
  teamspaces: TeamspaceItem[],
  setTeamspacesListInContext: (value: TeamspaceItem[]) => void,
) {
  persistTeamspacesToStorage(teamspaces, setTeamspacesListInContext);
}
